<ng-container *ngIf="magazine; else placeholder">

    <ng-container *ngIf="isLarge; else small">

        <div *ngIf="getPrimaryPicture(sharedMagazinePictureFormat.Full) as url"
             [style.backgroundImage]="'url(' + url + ')'"
             class="largeArticle">

            <h2 [innerHtml]="magazine.Titre | sanitize:'html'">
            </h2>

            <kal-button kalTheme="primary"
                        (click)="openMagazineDialog()">
                En savoir plus
            </kal-button>

        </div>

    </ng-container>

    <ng-template #small>

        <div class="smallArticle">

            <img *ngIf="getPrimaryPicture(sharedMagazinePictureFormat.Thumbnail) as url"
                 [src]="url"/>

            <h2 [innerHtml]="magazine.Titre | sanitize:'html'">
            </h2>

            <div [innerHtml]="magazine.Summary | sanitize:'html'">
            </div>

            <div class="validation-line">
                <kal-button kalTheme="primary"
                            (click)="openMagazineDialog()">
                    En savoir plus
                </kal-button>
            </div>

        </div>

    </ng-template>

</ng-container>

<ng-template #placeholder>
    <div class="placeholder"></div>
</ng-template>
